import { ReduxAction } from './../../constants';
const initialState = {};

const userInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReduxAction.userInfoSet: {
      return {
        ...state,
        userInfo: action.payload,
      };
    }
    // FEATURE DISABLED (Release july-2026)
    // case ReduxAction.activePersonaApplied: {
    //   return {
    //     ...state,
    //     userInfo: {
    //       ...state.userInfo,
    //       SPGGroups: action.payload,
    //     },
    //   };
    // }
    default:
      return state;
  }
};
export default userInfoReducer;
